import React, { useState, useEffect } from 'react';
import { auth, db } from '../../firebase';
import { doc, getDoc, updateDoc, setDoc } from 'firebase/firestore';
import Navbar from '../../components/Navbar';
import { Toaster, toast } from 'react-hot-toast';
import Confetti from 'react-confetti';
import { useWindowSize } from '@uidotdev/usehooks';

export default function ReactionSpeedGame() {
  const { width, height } = useWindowSize();

  const [waiting, setWaiting] = useState(true);
  const [started, setStarted] = useState(false);
  const [reactionTime, setReactionTime] = useState(null);
  const [startTime, setStartTime] = useState(0);
  const [plays, setPlays] = useState(0);
  const [limitReached, setLimitReached] = useState(false);
  const [loading, setLoading] = useState(true);
  const [showConfetti, setShowConfetti] = useState(false);
  const [floatingBonus, setFloatingBonus] = useState(null);

  const [maxPlays, setMaxPlays] = useState(200);

  useEffect(() => {
    const checkUser = async () => {
      if (!auth.currentUser) return;
      const userRef = doc(db, 'users', auth.currentUser.uid);
      const snap = await getDoc(userRef);
      if (!snap.exists()) return;
      const data = snap.data();
      const isPro = (data.accessType || '').toLowerCase() === 'pro';
      setMaxPlays(isPro ? 200 : 25);
      const today = new Date().toDateString();
      const todayPlays = data.reactionPlaysDate === today ? data.reactionPlays || 0 : 0;
      setPlays(todayPlays);
      setLimitReached(todayPlays >= maxPlays);
      setLoading(false);
    };
    checkUser();
  }, []);

  const startTest = () => {
    setWaiting(true);
    setStarted(false);
    setReactionTime(null);
    const delay = Math.floor(Math.random() * 4000) + 1000;
    setTimeout(() => {
      setStartTime(Date.now());
      setWaiting(false);
      setStarted(true);
    }, delay);
  };

  const updateLeaderboard = async (timeTaken, chronos) => {
    const userId = auth.currentUser.uid;
    const userRef = doc(db, 'leaderboard_master', userId);
    const profileRef = doc(db, 'users', userId);
    const profileSnap = await getDoc(profileRef);
    let playerName = 'BrainyPlayer';
    if (profileSnap.exists()) {
      const data = profileSnap.data();
      if (data.name) playerName = data.name;
      else if (auth.currentUser.displayName) playerName = auth.currentUser.displayName;
    }
const leaderboardSnap = await getDoc(userRef);
const previousData = leaderboardSnap.exists() ? leaderboardSnap.data() : {};
await setDoc(userRef, {
  name: playerName,
  chronos,
  lastPlayed: new Date().toDateString(),
  bestReactionTime: Math.min(
    timeTaken,
    previousData.bestReactionTime || Infinity
  )
}, { merge: true });

  };

// Fix: show warning and reset game if clicked while waiting (red)
const handleClick = async () => {
  if (!started) return;

  const endTime = Date.now();
  const timeTaken = endTime - startTime;

    if (waiting || startTime === 0 || timeTaken < 30) {
    toast.error('⛔ Too Early! Wait for green.', {
      style: { background: '#fecaca', color: '#7f1d1d', fontWeight: 'bold' }
    });
    setStarted(false);
    setWaiting(true);
    setStartTime(0);
    setReactionTime(null);
    return;
  }


  if (!started || startTime === 0 ) {
    toast.error('⏱ Too Soon! Wait for green!', {
      style: { background: '#fecaca', color: '#7f1d1d' }
    });
    setStarted(false);
    setWaiting(true);
    setStartTime(0);
    setReactionTime(null);
    return;
  }

 
  if (timeTaken < 30) return;

  setReactionTime(timeTaken);
  setStarted(false);
  toast.success(`⚡ Reaction Time: ${timeTaken} ms`);

  // 🧠 Only continue to update stats if player waited correctly
  const bonus = timeTaken < 200 ? 4 : timeTaken < 400 ? 2 : 1;
  const userRef = doc(db, 'users', auth.currentUser.uid);
  const snap = await getDoc(userRef);
  const data = snap.data();
  const today = new Date().toDateString();
  const updatedPlays = data.reactionPlaysDate === today ? (data.reactionPlays || 0) + 1 : 1;
  const updatedChronos = (data.chronos || 0) + bonus;
  const prevBest = data.reactionBestTime || Infinity;

  const updatePayload = {
    chronos: updatedChronos,
    reactionPlays: updatedPlays,
    reactionPlaysDate: today
  };

  if (timeTaken < prevBest) {
    updatePayload.reactionBestTime = timeTaken;
    toast.success('🏅 New Personal Best!', {
      style: { background: '#d9f99d', color: '#365314', fontWeight: 'bold' }
    });
  }

  await updateDoc(userRef, updatePayload);
  setPlays(updatedPlays);
  setFloatingBonus(`+${bonus}`);
  setTimeout(() => setFloatingBonus(null), 1200);
  if (updatedPlays >= maxPlays) setLimitReached(true);
  if (timeTaken < 250) {
    setShowConfetti(true);
    setTimeout(() => setShowConfetti(false), 2000);
  }
  updateLeaderboard(timeTaken, updatedChronos);
};




  if (loading) return <div className="text-center mt-10">Loading...</div>;
  if (limitReached) {
    return (
      <>
        <Navbar />
        <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-yellow-100 to-pink-100">
          <Toaster />
          <Confetti width={width} height={height} recycle={false} numberOfPieces={250} />
          <div className="text-center">
            <h1 className="text-3xl font-bold text-purple-700 mb-4">🎉 Daily Limit Reached!</h1>
            <p className="text-lg text-gray-700">You’ve completed all {maxPlays} plays for today.</p>
            <p className="text-md text-purple-600 mt-2">Come back tomorrow to test your reflexes again!</p>
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <Navbar />
      <Toaster />
      {showConfetti && <Confetti width={width} height={height} />} 
      <div className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-br from-green-100 to-purple-100">
        <h1 className="text-3xl font-bold mb-8 text-purple-800">⚡ Quick Tap ⚡</h1>
                <h3 className="text-2xl font-bold mb-8 text-purple-500">⚡ Check How Fast You Are! ⚡</h3>


        <button
          onClick={waiting ? null : handleClick}
          className={`w-64 h-64 rounded-full text-white text-xl font-bold shadow-lg transition-all duration-300 relative ${
            waiting ? 'bg-red-400 animate-pulse' : 'bg-green-500 hover:scale-105'
          }`}
        >
          {floatingBonus && (
            <div className="absolute top-4 left-1/2 transform -translate-x-1/2 text-green-700 text-2xl font-bold animate-bounce">
              {floatingBonus}
            </div>
          )}
          {waiting ? 'Wait for Green...' : 'Tap Now!'}
        </button>

        {reactionTime && (
          <p className="mt-6 text-lg font-semibold text-gray-800">
            ⏱ You reacted in {reactionTime} ms
          </p>
        )}

        <button
          onClick={startTest}
          className="mt-8 px-6 py-3 bg-purple-600 text-white rounded-lg hover:bg-purple-700"
        >
          {reactionTime ? 'Try Again' : 'Start Test'}
        </button>

        <p className="mt-6 text-sm text-gray-600">Plays today: {plays} / {maxPlays}</p>
      </div>
    </>
  );
}
